var app = angular.module("leonardo");

var ReportDeleteDialog = function($scope, $rootScope, FormErrorsService) {
  $scope.report = $scope.ngDialogData.report;
  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    $scope.report.remove().then(function() {
      $rootScope.$broadcast('report:deleted');
      $scope.closeThisDialog();
    });
  };
};

app.controller('ReportDeleteDialog', ['$scope', '$rootScope', 'FormErrorsService', ReportDeleteDialog]);
